<div class="container-fuild">
    <div>

        <div class="row" style="margin-top: 20px;">


            <div class="col-12 col-sm-12 col-md-3 col-lg-3">

                <app-menu></app-menu>

            </div>

            <div class="col-12 col-sm-12 col-md-9 col-lg-9" style="min-height: 600px; border-left:1px solid #ccc;">
                <h5 style="font-size: +1.2em; border-bottom: 1px solid #ccc; padding-bottom: 15px;">
                    เพิ่มเติม/แก้ไข คอร์ส Category
                </h5>


                <!-- <form [formGroup]="courseImport" (ngSubmit)="onImport()">
                    <div class="form-group row">
                      <label for="ops_course_id" class="col-sm-2 col-form-label">ops_course_id</label>
                      <div class="col-sm-10">
                        <input
                            type="text"
                            class="form-control"
                            id="ops_course_id"
                            placeholder="ops_course_id"
                            formControlName="ops_course_id">
                      </div>
                    </div>
                    <div class="form-group row">
                        <label for="submit" class="col-sm-2 col-form-label"></label>
                        <div class="col-sm-10">
                          <button type="submit" class="btn btn-primary">Import</button><hr>
                          <span>{{course['name']}}</span>
                        </div>
                      </div>
                </form> -->


            </div>

        </div>
    </div>
</div>


